import z from "zod";

const pandadocErrorTypeValues = [
  "UNKNOWN",
  "TIMEOUT_WAITING_FOR_DOCUMENT_DRAFT_STATUS",
  "FAILED_TO_CREATE_DOCUMENT_FROM_URL",
  "FAILED_TO_UPLOAD_TEMPLATE_AS_SECTION_OF_DOCUMENT",
  "TIMEOUT_WAITING_FOR_PROCESSED_DOCUMENT_SECTION",
  "FAILED_TO_CREATE_DOCUMENT_FROM_TEMPLATE",
  "FAILED_TO_CREATE_DOCUMENT_SIGNING_LINK",
  "ORPHANED_FIELDS_REMAIN_AFTER_ASSIGNMENT",
  "CONDITIONAL_BLOCK_POLL_FAILED",
] as const;
const pandadocErrorTypeSchema = z.enum(pandadocErrorTypeValues);
const PandadocErrorType = pandadocErrorTypeSchema.enum;
type PandadocErrorType = z.infer<typeof pandadocErrorTypeSchema>;

export type PandadocErrors =
  | { errorType: typeof PandadocErrorType.UNKNOWN; data: undefined }
  | { errorType: typeof PandadocErrorType.TIMEOUT_WAITING_FOR_DOCUMENT_DRAFT_STATUS; data: { documentId: string } }
  | {
      errorType: typeof PandadocErrorType.FAILED_TO_CREATE_DOCUMENT_FROM_URL;
      data: { url: string };
    }
  | {
      errorType: typeof PandadocErrorType.FAILED_TO_UPLOAD_TEMPLATE_AS_SECTION_OF_DOCUMENT;
      data: { templateId: string; documentId: string };
    }
  | {
      errorType: typeof PandadocErrorType.TIMEOUT_WAITING_FOR_PROCESSED_DOCUMENT_SECTION;
      data: { documentId: string; sectionId: string };
    }
  | {
      errorType: typeof PandadocErrorType.FAILED_TO_CREATE_DOCUMENT_FROM_TEMPLATE;
      data: { templateUuid: string };
    }
  | {
      errorType: typeof PandadocErrorType.FAILED_TO_CREATE_DOCUMENT_SIGNING_LINK;
      data: { documentId: string };
    }
  | {
      errorType: typeof PandadocErrorType.ORPHANED_FIELDS_REMAIN_AFTER_ASSIGNMENT;
      data: { pandadocDocumentId: string; remainingOrphanedFieldIds: string[] };
    }
  | {
      errorType: typeof PandadocErrorType.CONDITIONAL_BLOCK_POLL_FAILED;
      data: { pandadocDocumentId: string; errorMessage: string };
    };

export const pandadocErrorDetails: Record<PandadocErrorType, { sentryDescription: string }> = {
  UNKNOWN: { sentryDescription: "Unknown Pandadoc Error" },
  TIMEOUT_WAITING_FOR_DOCUMENT_DRAFT_STATUS: { sentryDescription: "Timeout waiting for document draft status" },
  FAILED_TO_CREATE_DOCUMENT_FROM_URL: { sentryDescription: "Failed to create document from url" },
  FAILED_TO_UPLOAD_TEMPLATE_AS_SECTION_OF_DOCUMENT: {
    sentryDescription: "Failed to upload template as section of document",
  },
  TIMEOUT_WAITING_FOR_PROCESSED_DOCUMENT_SECTION: {
    sentryDescription: "Timeout waiting for processed document section",
  },
  FAILED_TO_CREATE_DOCUMENT_FROM_TEMPLATE: {
    sentryDescription: "Failed to create document from template",
  },
  FAILED_TO_CREATE_DOCUMENT_SIGNING_LINK: {
    sentryDescription: "Failed to create document signing link",
  },
  ORPHANED_FIELDS_REMAIN_AFTER_ASSIGNMENT: {
    sentryDescription: "Orphaned fields remain after assignment",
  },
  CONDITIONAL_BLOCK_POLL_FAILED: {
    sentryDescription: "PandaDoc conditional-block poll failed after repeated errors",
  },
};
